import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  HiHome,
  HiInformationCircle,
  HiShoppingBag,
  HiBadgeCheck,
  HiMail,
  HiMenu,
  HiX,
  HiPhone,
} from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import "./Navbar.css";

const navLinks = [
  { label: "Home", href: "/", icon: HiHome },
  { label: "About Us", href: "/about", icon: HiInformationCircle },
  { label: "Products", href: "/products", icon: HiShoppingBag },
  // { label: "Quality", href: "/quality", icon: HiBadgeCheck },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = isDrawerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDrawerOpen]);

  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);
  const closeDrawer = () => setIsDrawerOpen(false);

  // Helper function to check if link is active
  const isActive = (href) => {
    if (href === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(href);
  };

  // Phone and WhatsApp numbers (update with your actual numbers)
  const phoneNumber = "+1234567890";
  const whatsappNumber = "+1234567890";

  return (
    <>
      <nav className={`gnv2-nav${isScrolled ? " gnv2-nav--scrolled" : ""}`}>
        <div className="gnv2-nav__inner">
          {/* Brand — logo */}
          <Link to="/" className="gnv2-brand" onClick={closeDrawer}>
            <div className="gnv2-brand__container">
              <img src="/assets/Arklon logo.png" alt="Arklon Logo" className="gnv2-brand__logo" />
              {/* <span className="gnv2-brand__name">Lapspool</span> */}
            </div>
          </Link>

          {/* Desktop links */}
          <ul className="gnv2-links">
            {navLinks.map(({ label, href }) => (
              <li key={href}>
                <Link
                  to={href}
                  className={`gnv2-links__item${isActive(href) ? " gnv2-links__item--active" : ""}`}
                >
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="gnv2-cta">
                <span>Contact</span>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="gnv2-cta__arrow"
                  aria-hidden="true"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Link>
            </li>
          </ul>

          {/* Mobile Action Icons (Phone + WhatsApp) + Hamburger */}
          <div className="gnv2-mobile-actions">
            <button
              className={`gnv2-burger${isDrawerOpen ? " gnv2-burger--open" : ""}`}
              onClick={toggleDrawer}
              aria-label="Toggle navigation"
              aria-expanded={isDrawerOpen}
            >
              {isDrawerOpen ? <HiX size={24} /> : <HiMenu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Bottom Bar */}
      <div className="gnv2-bottom-bar">
        {navLinks.map(({ label, href, icon: Icon }) => (
          <Link
            key={href}
            to={href}
            className={`gnv2-bottom-bar__item${isActive(href) ? " gnv2-bottom-bar__item--active" : ""}`}
            onClick={closeDrawer}
          >
            <Icon size={22} />
            <span className="gnv2-bottom-bar__label">{label}</span>
          </Link>
        ))}
        <Link
          to="/contact"
          className={`gnv2-bottom-bar__item${isActive("/contact") ? " gnv2-bottom-bar__item--active" : ""}`}
          onClick={closeDrawer}
        >
          <HiMail size={22} />
          <span className="gnv2-bottom-bar__label">Contact</span>
        </Link>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`gnv2-drawer${isDrawerOpen ? " gnv2-drawer--open" : ""}`}
        aria-hidden={!isDrawerOpen}
      >
        {/* Backdrop */}
        <div className="gnv2-drawer__backdrop" onClick={closeDrawer} />

        {/* Panel */}
        <div className="gnv2-drawer__panel">
          <div className="gnv2-drawer__eyebrow">
            <span className="gnv2-drawer__eyebrow-label">Navigation</span>
          </div>

          <ul className="gnv2-drawer__links">
            {navLinks.map(({ label, href, icon: Icon }, i) => (
              <li key={href} style={{ "--item-index": i }}>
                <Link
                  to={href}
                  className={`gnv2-drawer__link${isActive(href) ? " gnv2-drawer__link--active" : ""}`}
                  onClick={closeDrawer}
                >
                  <Icon size={20} className="gnv2-drawer__link-icon" />
                  <span className="gnv2-drawer__link-num">0{i + 1}</span>
                  {label}
                </Link>
              </li>
            ))}
            <li style={{ "--item-index": navLinks.length }}>
              <Link
                to="/contact"
                className="gnv2-drawer__cta"
                onClick={closeDrawer}
              >
                <HiMail size={18} />
                Contact Us
              </Link>
            </li>
          </ul>

          <div className="gnv2-drawer__footer">
            <span className="gnv2-drawer__footer-brand">Arklon</span>
            <span className="gnv2-drawer__footer-copy">
              © {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;